// Legacy, keep for BTT page only.
// Replaced with tabs carousel to support elementor default widget.

// TODO: Remove this file and all references to it and replace the BTT page with the new tabs carousel.

jQuery(document).ready(function ($) {

    const mobileWidth = window.matchMedia('(max-width: 768px)');
    let timerInside, timerOutside,
        timeouts = [];

    // Observe videos
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
            const video = entry.target
            if (entry.intersectionRatio === 1) {
                video.play();
                video.volume = 1;
            } else {
                video.pause();
            }
        });
    }, {
        threshold: 1,
    });

    function observeVideos() {
        const videos = document.querySelectorAll(".carousel-slide video")

        for (let i = 0; i < videos.length; i++) {
            const video = videos[i];
            observer.observe(video)
        }
    }

    function observeVideosDisconnect() {
        document.querySelectorAll(".carousel-slide video")
    }

    // Custom Interval

    function slidesInterval(fn, time, elAmount, i = 1) {
        function next(i) {
            if (i <= elAmount) fn(i);
            if (i === elAmount) i = 0;
            timerInside = setTimeout(next, time, i + 1);
            timeouts.push(timerInside);
        }

        timerOutside = setTimeout(next, 0, i);
    }

    function initSlider(carousel) {
        let slideNumberStart = 1,
            timeBetweenSlides = 14000,
            carouselSlide = $('.carousel-slide[slider-id=' + carousel + ']'),
            carouselSlider = $('.carousel[slider-id=' + carousel + ']'),
            carouselNavItems = carouselSlider.find('.carousel-nav-item'),
            slidesAmount = $('.carousel-slide[slider-id=' + carousel + ']').length,
            autoChange = carouselSlider.attr('data-disable-slide-auto-change') !== 'yes';
        carouselNavItem = $('.carousel-nav[slider-id=' + carousel + '] .carousel-nav-item');

        // Highest Slider

        function getHighestSlider() {
            let slidesHeight = [];
            carouselSlide.each(function (index, slide) {
                slidesHeight.push($(slide).height());
            })
            return Math.max(...slidesHeight);
        }

        // Set Initial Data (Attributes & Height)

        carouselSlide.each(function () {
            $(this).attr('data-slide', slideNumberStart++);
            setTimeout(function () {
                $(this).css('height', getHighestSlider);
            }, 50);
        })


        // Setting Slide Change.

        let activeTab = false;
        function activateSlide(slide, firstLoad = false) {
            activeTab = true;
            let currId = $(slide).attr('id');
            carouselSlide.fadeOut();
            const slideContent = $('.carousel-slide[slider-id=' + carousel + '][id=' + currId + ']');
            slideContent.fadeIn();
            $(slide).addClass('active');
            $('.carousel-nav[slider-id=' + carousel + '] .carousel-nav-item').find('.carousel-bar-indicator__inside').css('transition', '0s');
            $('.carousel-nav[slider-id=' + carousel + '] .carousel-nav-item').not(slide).removeClass('active');

            if (!autoChange) {
                const videos = carouselSlide.find('video');
                videos.each(function (i, video) {
                    video.pause();
                    video.volume = 1;
                });

                const video = slideContent.find('video');
                if (video.length) {
                    video.get(0).play();
                    video.get(0).volume = 1;
                    if (!firstLoad) {
                        video.get(0).muted = false;
                    }
                }
            }
        }

        carouselNavItem.click(function () {
            activateSlide(this)
        })

        // Set initial state of first slide.

        function slideChange(i) {
            if (!activeTab) {

                // Get Current ID of slide

                activeSlideId = $('.carousel-slide[slider-id=' + carousel + '][data-slide=' + i + ']').attr('id');

                // Show / Hide Slides

                carouselSlide.fadeOut();
                $('.carousel-slide[slider-id=' + carousel + '][data-slide=' + i + ']').fadeIn();

                // Active / Deactive tabs

                $('.carousel-nav[slider-id=' + carousel + '] .carousel-nav-item').removeClass('active');
                $('.carousel-nav[slider-id=' + carousel + '] .carousel-nav-item[id=' + activeSlideId + ']').addClass('active');

                // Add transition to active tabs only

                $('.carousel-nav[slider-id=' + carousel + '] .carousel-bar-indicator__inside').css('transition', '0s');
                $('.carousel-nav[slider-id=' + carousel + '] .carousel-nav-item.active .carousel-bar-indicator__inside').css('transition', 'width ' + timeBetweenSlides / 1000 + 's ease-in');

            }
        }

        if (autoChange) {
            slidesInterval(slideChange, timeBetweenSlides, slidesAmount);
        } else {
            activateSlide(carouselNavItems[0], true);
        }

        $(".carousel-slide video").on('play', function(e) {
            const slideId = $(this).closest('.carousel-slide').attr('data-slide');
            const sliderId = $(this).closest('.carousel-slide').attr('slider-id');
            
            if (slideId) {    
                $(`.carousel-slide`).each(function (i, slide) {
                    const curSlideId = $(slide).attr('data-slide');
                    const curSliderId = $(slide).attr('slider-id');
    
                    if (
                        curSliderId != sliderId || 
                        (curSlideId != slideId && curSliderId == sliderId)
                    ) {
                        const video = $(slide).find('video');
                        if (video.length) {
                            video.get(0).pause();
                        }
                    }
                });
            }
        });
    };

    $(window).on('resize', function () {
        if (mobileWidth.matches) {
            timeouts.forEach(timeout => {
                clearTimeout(timeout);
            });

            observeVideos();
        } else {
            observer.disconnect();
        }
    });

    if ($('.carousel').length > 0) {
        let ids = [];
        $('.carousel').each(function (index, carousel) {
            ids.push($(carousel).attr('slider-id'));
        });
        if (!mobileWidth.matches) {
            ids.forEach(id => {
                initSlider(id);
            });
            observer.disconnect();
        } else {
            observeVideos();
        }
    }

});

